// SurveyJS's own UI strings (validation errors, "Other", "Clear", ...) for the
// "es" survey locale, from locales/es/common.json (surveyjs.*). English keeps
// survey-core's built-in strings untouched.
import { surveyLocalization } from "survey-core";
import { resources } from "./resources";

surveyLocalization.locales["es"] = {
  ...surveyLocalization.locales["en"],
  ...resources.es.translation.common.surveyjs,
};
surveyLocalization.localeNames["es"] = "español";
